import { render, staticRenderFns } from "./pointPoolOrg.vue?vue&type=template&id=143d9fa7"
import script from "./pointPoolOrg.vue?vue&type=script&lang=js"
export * from "./pointPoolOrg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports